exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box_a433e0d{min-height:125px;padding:10px;border:1px solid #f0f2f5}.box_a433e0d,.inputW_9199d72{width:400px!important}.input_8f5836f{width:60px!important;display:inline-block!important;border:1px solid #dcdfe6}.label_8f19ddc{color:#999!important}", ""]);

// exports
exports.locals = {
	"box": "box_a433e0d",
	"inputW": "inputW_9199d72",
	"input": "input_8f5836f",
	"label": "label_8f19ddc"
};